import * as React from 'react';
import ViewerLoadingContainer from 'components/monitor/ViewerLoadingContainer';

const ViewerLoadingTime = () => {
  return <ViewerLoadingContainer />;
};

export default ViewerLoadingTime;
